import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import EosLogo from '../layout/EosLogo';
import CelebrationModal from '../settings/CelebrationModal';

function CompanyConfigTest() {
  const [companyName, setCompanyName] = useState('');
  const [industry, setIndustry] = useState('');
  const [size, setSize] = useState('');
  const [description, setDescription] = useState('');
  const [mission, setMission] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showCelebration, setShowCelebration] = useState(false);
  
  function handleSubmit(e) {
    e.preventDefault();
    
    if (!companyName || !industry || !size) {
      return setError('Please fill out all required fields');
    }
    
    // Simulate loading state briefly
    setError('');
    setLoading(true);
    
    // Simulate API call with timeout
    setTimeout(() => {
      setLoading(false);
      setShowCelebration(true);
    }, 1000);
  }
  
  // Handle when celebration modal is closed
  const handleCelebrationClose = () => {
    setShowCelebration(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Diagonal repeating text background */}
      <div className="absolute inset-0 overflow-hidden" style={{ transform: 'rotate(-45deg)' }}>
        <div className="absolute inset-0 flex flex-wrap items-center justify-center"
          style={{ 
            transform: 'scale(2.5)',
            gap: '50px',
            opacity: 0.04
          }}>
          {Array(100).fill(0).map((_, i) => (
            <div key={i} className="text-5xl font-bold text-black whitespace-nowrap" style={{ letterSpacing: '4px' }}>
              eosyes
            </div>
          ))}
        </div>
      </div>
      
      <div className="max-w-lg w-full relative z-10 px-4 py-8">
        <div className="bg-white bg-opacity-90 backdrop-filter backdrop-blur-lg rounded-2xl shadow-xl 
          p-8 border border-white border-opacity-30 transition-all duration-300 hover:shadow-eos-lg">
          <div className="flex justify-center mb-6">
            <div className="transition-transform duration-300 transform hover:scale-110 w-24 h-24">
              <EosLogo />
            </div>
          </div>
          
          <h2 className="text-center text-2xl font-bold text-gray-800 mb-3 font-heading">
            Configure Your Company (Test)
          </h2>
          <p className="text-center text-sm text-gray-600 mb-6">
            This is a test form - submitting will show the celebration modal
          </p>
          
          {error && (
            <div className="bg-red-50 bg-opacity-70 border-l-4 border-red-500 text-red-700 p-3 mb-6 rounded-r-md shadow-sm animate-fade-in" role="alert">
              <p className="font-bold font-heading">Error</p>
              <p>{error}</p>
            </div>
          )}
          
          <form className="space-y-5" onSubmit={handleSubmit}>
            <div className="transition-all duration-300 hover:bg-white hover:bg-opacity-20 p-3 rounded-md -mx-3 group">
              <label htmlFor="company-name" className="block text-sm font-medium text-gray-700 mb-1 font-heading group-hover:text-orange-600">
                Company Name <span className="text-red-500">*</span>
              </label>
              <input
                id="company-name"
                name="company-name"
                type="text"
                required
                className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 
                  placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-2 focus:ring-orange-500 
                  focus:border-orange-500 sm:text-sm transition-all duration-300 bg-white bg-opacity-50"
                placeholder="Acme Inc."
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
              />
            </div>
            
            <div className="transition-all duration-300 hover:bg-white hover:bg-opacity-20 p-3 rounded-md -mx-3 group">
              <label htmlFor="industry" className="block text-sm font-medium text-gray-700 mb-1 font-heading group-hover:text-orange-600">
                Industry <span className="text-red-500">*</span>
              </label>
              <select
                id="industry"
                name="industry"
                required
                className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 
                  text-gray-900 focus:outline-none focus:ring-2 focus:ring-orange-500 
                  focus:border-orange-500 sm:text-sm transition-all duration-300 bg-white bg-opacity-50"
                value={industry}
                onChange={(e) => setIndustry(e.target.value)}
              >
                <option value="">Select an industry</option>
                <option value="Technology">Technology</option>
                <option value="Healthcare">Healthcare</option>
                <option value="Finance">Finance</option>
                <option value="Retail">Retail</option>
                <option value="Manufacturing">Manufacturing</option>
                <option value="Education">Education</option>
                <option value="Other">Other</option>
              </select>
            </div>
            
            <div className="transition-all duration-300 hover:bg-white hover:bg-opacity-20 p-3 rounded-md -mx-3 group">
              <label htmlFor="size" className="block text-sm font-medium text-gray-700 mb-1 font-heading group-hover:text-orange-600">
                Company Size <span className="text-red-500">*</span>
              </label>
              <select
                id="size"
                name="size"
                required
                className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 
                  text-gray-900 focus:outline-none focus:ring-2 focus:ring-orange-500 
                  focus:border-orange-500 sm:text-sm transition-all duration-300 bg-white bg-opacity-50"
                value={size}
                onChange={(e) => setSize(e.target.value)}
              >
                <option value="">Select company size</option>
                <option value="1-10">1-10 employees</option>
                <option value="11-50">11-50 employees</option>
                <option value="51-200">51-200 employees</option>
                <option value="201-500">201-500 employees</option>
                <option value="501-1000">501-1000 employees</option>
                <option value="1000+">1000+ employees</option>
              </select>
            </div>

            <div className="pt-3">
              <button
                type="submit"
                disabled={loading}
                className="w-full flex justify-center py-2 px-6 border border-transparent rounded-lg 
                  shadow-eos-orange text-sm font-medium text-white bg-orange-500 hover:bg-orange-600 
                  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500
                  transition-all duration-300 btn-pop"
              >
                {loading ? (
                  <div className="flex items-center">
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Saving...
                  </div>
                ) : 'Test Celebration Modal'}
              </button>
            </div>
          </form>
          
          <div className="mt-8 pt-4 border-t border-gray-200 text-center">
            <p className="text-xs text-gray-500 mt-1">
              This is a test component to verify the celebration modal works
            </p>
          </div>
        </div>
      </div>
      
      {/* Celebration Modal */}
      <CelebrationModal 
        isOpen={showCelebration} 
        onClose={handleCelebrationClose} 
        userName="Test User" 
      />
    </div>
  );
}

export default CompanyConfigTest; 